module.exports = __webpack_public_path__ + "img/favicon.6dfebc7a.ico";